const toEuro = (cents) => {
   return new Intl.NumberFormat('nl-NL', { style: 'currency', currency: 'EUR' }).format(cents/100);
}
const toFloat = (cents) => {
   return (cents / 100).toFixed(2)
}
export  {toEuro, toFloat}


